import React from "react";

const CampaignAnalytics = ({ analytics }) => {

    return (

        <div className="campaign-analytics">

            <h3>Campaign Analytics</h3>

            <div className="analytics-grid">

                <div className="analytics-card">

                    <h4>Impressions</h4>

                    <h2>{analytics.impressions || 0}</h2>

                </div>

                <div className="analytics-card">

                    <h4>Clicks</h4>

                    <h2>{analytics.clicks || 0}</h2>

                </div>

                <div className="analytics-card">

                    <h4>Conversions</h4>

                    <h2>{analytics.conversions || 0}</h2>

                </div>

                <div className="analytics-card">

                    <h4>Revenue</h4>

                    <h2>₹{analytics.revenue || 0}</h2>

                </div>

            </div>

        </div>

    );

};

export default CampaignAnalytics;